var SHOW_HIDE_ANIMATION_DURATION = 250;
var COUNTDOWN_ANIMATION = 'countdown';

export { COUNTDOWN_ANIMATION, SHOW_HIDE_ANIMATION_DURATION };
//# sourceMappingURL=Toast.constants.js.map
